import { FC, ReactElement, ReactNode } from "react";
import { Box, Card } from "@mui/material";
import styles from "../assests/scss/themes-vars.module.scss";
interface ContentProps {
  children: ReactNode;
}

export const Content: FC<ContentProps> = ({ children }): ReactElement => {
  var mnuHeaderHeight = document.getElementById("sidebarMnuHeader")?.clientHeight
  var footerHeight = document.getElementById("footer")?.clientHeight
  const height: string =
    'calc(100% - '
    + (mnuHeaderHeight ? mnuHeaderHeight : 0 + (footerHeight ? footerHeight : 0)).toString()
    + ')'
  return (
    <Box
      sx={{
        padding: "0px 30px",
        minHeight: height,
        maxWidth: "100vw",
        flexGrow: 1,
        backgroundColor: styles.backgroundColor
      }}
    >
      <Card
        sx={{
          boxShadow: "none",
          display: 'flex',
          justifyContent: 'center',
          paddingTop: "5px",
          paddingBottom: '20px',
          my: '0',
          mx: 'auto',
          height: '100%',
          width: { xs: '100%', sm: '100%', md: '100%', lg: '100%', xl: '100%' },
          backgroundColor: styles.backgroundColor,
          color: styles.contentColor
        }}
      >
        {children}
      </Card>
    </Box>
  )
}

export default Content;